import React, { FC, useEffect, useState, useMemo } from "react";
import { Button, Table, Tooltip, Upload } from "antd";
import { YhBox } from "@/components/YhBox";
import { ColumnsType } from "antd/es/table";
import { useRepairTemplateDetailsModel } from "./repairTemplateDetailsModels";
import { RouterParamType } from "@/model/navModel";
import { DetailType } from "@/types/ScmEnums";
import { IItemDetailList } from "../../repairTemplateType";
import { bigNumber, formatIntPoint, formatNum } from "@/utils/utils";
import { components } from "@/components/YHEditTable/editTable";
import FontIcon from "@/components/YhIcon";
import { useVrmModel } from "@/model/vrmModel"
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";
import { YhBut } from "@/components/YhButton";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums";
import { roleColumnModel } from "@/utils/roleColumn";
import useGlobalModel from "@/model/globalModel";
import { useSaleSoDetailModel } from "@/views/sale/so/view/details/saleSoDetailModel";
import { importPropsConfig } from "@/utils/importFile";

export const ItemTableBox: FC<RouterParamType> = ({ id, mode, parentInfo }) => {
    const { shopAndOrg: { shopId }, setLoadingInfo } = useGlobalModel()
    const {
        setItemModel,
        detailEditForm,
        detailItemAddList, setDetailItemAddList,
        detailItemAddDataRowKeys, setDetailItemAddDataRowKeys,
        setDetailItemAddDataRow,
        detailItemEditList, setDetailItemEditList,
        detailItemEditDataRowKeys, setDetailItemEditDataRowKeys,
        setDetailItemEditDataRow,
        detailItemLookList, transformsToPoMaterialDetailList,
        detailItemDetailList, transformsToPoItemDetailList,
    } = useRepairTemplateDetailsModel();
    const { user: { roles } } = useGlobalModel();
    const { getRoleColumns } = roleColumnModel();

    const action = <>
        {mode !== "look" && <>
            <YhAuth resCode={ResourceAuthEnum.VRM2_DATA_REPAIRTEMPLATE_DE_ADDITEM}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    onClick={() => { setItemModel(true) }}
                >新增项目</Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.VRM2_DATA_REPAIRTEMPLATE_DE_RMITEM}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    onClick={() => detailItemDetailList(mode, parentInfo)}
                >删除项目</Button>
            </YhAuth>
        </>}
    </>;

    const typeItemList = {
        "add": [...detailItemAddList],
        "edit": [...detailItemEditList],
        "look": [...detailItemLookList],
    }

    const itemColumn = [
        {
            title: '序号',
            fixed: "left",
            width: 60,
            render: (t: any, r: any, i: number) => <>{i + 1}</>
        }, {
            title: '项目编码',
            width: 120,
            dataIndex: 'itemCode',
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            title: '项目名称',
            width: 160,
            dataIndex: 'itemName',
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            title: '工时',
            width: 100,
            dataIndex: 'workHour',
            editable: mode !== "look",
        },
        // {
        //     title: '单价',
        //     width: 100,
        //     dataIndex: 'price',
        // }, {
        //     title: '工时费',
        //     width: 100,
        //     dataIndex: 'itemAmount',
        // }, 
        {
            title: '备注',
            width: 160,
            dataIndex: 'note',
            editable: mode !== "look",
        }, {
            title: '操作',
            width: 60,
            fixed: "right",
            align: "center",
            render: (text: any, record: any) => {
                mode !== "look" && <YhBut
                    type="delete"
                    txt="删除"
                    click={() => removeItem(record)}
                />
            }
        }
    ];

    const removeItem = (record: IItemDetailList) => {
        detailItemDetailList(mode, parentInfo, record)
    }
    const newSelectItemColums = () =>
        itemColumn.map((col: any, index) => {
            return {
                ...col,
                onCell: (record: IItemDetailList, rowIndex: number) => ({
                    colIndex: index + 1,
                    rowIndex,
                    record,
                    rules: col.rules,
                    options: col.options,
                    editType: col.editType,
                    suffix: col.suffix,
                    editable: mode == "look" ? false : col?.editable,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    mode: col.mode,
                    handleSave: handleItemSave,
                }),
            }
        })

    const roleColumns = useMemo(() => {
        //根据可视化配置处理需要展示相关列
        const params = { "code": "repairTemplate", "roleCodes": roles };
        return getRoleColumns("repairTemplate", "维修项目", newSelectItemColums(), params);
    }, [roles, typeItemList[mode], itemColumn]);
    const handleItemSave = (row: IItemDetailList) => {
        let { workHour, price, } = row
        workHour = +formatNum(workHour); //工时
        price = +formatNum(price); //工时费
        let newRow = {
            ...row,
            price,
            workHour,
            itemAmount: +formatNum(bigNumber.multiTimes(workHour, price)),
        }
        let newData = mode === "edit" ? detailItemEditList : detailItemAddList;
        const index = newData.findIndex((item) => row.itemCode === item.itemCode);
        const item = newData[index];
        newData.splice(index, 1, { ...item, ...newRow });
        mode === "edit" ? setDetailItemEditList([...newData]) : setDetailItemAddList([...newData])
    }
    //设置维修项目选中的行和数据
    const setTypeItemDetailDataRowKeysAndRow = async (selectedRowKeys: React.Key[], mode: string) => {
        if (mode === DetailType.add) {
            setDetailItemAddDataRowKeys(selectedRowKeys)
        } else if (mode === DetailType.edit) {
            setDetailItemEditDataRowKeys(selectedRowKeys)
        }
    }
    const setTypeItemDetailDataRow = async (selectedRows: IItemDetailList[], mode: string) => {
        if (mode === DetailType.add) {
            setDetailItemAddDataRow(selectedRows)
        } else if (mode === DetailType.edit) {
            setDetailItemEditDataRow(selectedRows)
        }
    }


    return (

        <>{action}
            <Table
                style={{ marginTop: 10 }}
                bordered
                rowKey={record => record.itemCode as string}
                rowClassName='editable-row yh-edit-table-tr'
                rowSelection={
                    mode === "look" ? undefined : {
                        selectedRowKeys: mode === DetailType.add ? detailItemAddDataRowKeys : detailItemEditDataRowKeys, //记录选中
                        onChange: (selectedRowKeys: React.Key[], selectedRows: IItemDetailList[]) => {
                            setTypeItemDetailDataRowKeysAndRow(selectedRowKeys, mode)
                            setTypeItemDetailDataRow(selectedRows, mode)
                        },
                        onSelectAll: (selected, selectedRows, changeRows) => {
                            setTypeItemDetailDataRow(selectedRows, mode)
                        }
                    }}
                columns={roleColumns}
                dataSource={typeItemList[mode] as IItemDetailList[]}
                components={components}
                pagination={false}
                scroll={{ x: 'max-content', y: 630 }}
            />
        </>
    )
}